import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as InfoIcon } from '@/assets/icons/info-icon.svg';

import styles from './Callout.module.css';

interface CalloutProps {
  variant?: 'error' | 'info' | 'success' | 'warning';
  children: React.ReactNode;
  className?: string;
}

const Callout: React.FC<CalloutProps> = ({ variant = 'info', children, className = '' }) => {
  const borderColor = {
    error: 'border-ph-red/30',
    info: 'border-ph-blue/30',
    warning: 'border-ph-orange/30',
    success: 'border-ph-green/30',
  }[variant];
  const textColor = {
    error: 'text-ph-red',
    warning: 'text-ph-orange',
    info: 'text-ph-blue',
    success: 'text-ph-green',
  }[variant];

  return (
    <div className={twMerge(styles.callout, borderColor, textColor, className)}>
      <InfoIcon className="h-5 w-5 shrink-0" />
      <span className="text-sm">{children}</span>
    </div>
  );
};

export default Callout;
